module.exports = __webpack_public_path__ + "img/fpga.10d765fd.jpg";